<div class="resultWrapper">
  <app-product-list-item
    *ngFor="let product of products; let i = index"
    [product]="product"
    [user]="user"
    [even]="i % 2 === 0"
    [cartProductsFrom]="cartProductsFrom"
    [cartProducts]="cartProducts"
  ></app-product-list-item>
</div>
